import React from "react"
import { Button, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import PickBasic from "./PickBasic"

const ScanedSuiteModal = ({
    scannedSuite,
    show,
    setShow
}: {
    scannedSuite?: Record<string, any>
    show: boolean
    setShow: Function
}) => {
    const { t } = useTranslation()

    return (
        <Modal
            size="xl"
            show={show}
            onHide={() => {
                setShow(false)
            }}
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{scannedSuite?.suite}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="">
                <PickBasic
                    picksBasic={scannedSuite?.ParcelSuites?.map((ps: Record<string, any>) => ps?.parcel)}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShow(false)}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ScanedSuiteModal
